export const ADD_TEMPLATE = "ADD_TEMPLATE"
export const GET_TEMPLATE = "GET_TEMPLATE"
export const ALL_TEMPLATE = "ALL_TEMPLATE"
export const EDIT_TEMPLATE = "EDIT_TEMPLATE"